export default function checkoutDelivery({ main, on, elm }) {
  const items = Array.from(elm.querySelectorAll('[data-delivery-item]'));

  if (!items.length) return;

  main(() => {
    initialize();
    window.addEventListener('resize', syncHeights);
    on('click', '[data-delivery-trigger]', toggleItem);
  });

  function initialize() {
    const initiallyOpenItem = items.find((item) => item.classList.contains('is-open')) || items[0];

    items.forEach(closeItem);
    openItem(initiallyOpenItem);
  }

  function syncHeights() {
    items.forEach(syncHeight);
  }

  function syncHeight(item) {
    const content = item.querySelector('[data-delivery-content]');

    if (!content) return;

    if (item.classList.contains('is-open')) {
      content.style.maxHeight = `${content.scrollHeight}px`;
    } else {
      content.style.maxHeight = '0px';
    }
  }

  function toggleItem(event) {
    const trigger = event.target.closest('[data-delivery-trigger]');
    const item = trigger?.closest('[data-delivery-item]');

    if (!item) return;

    items.forEach(closeItem);
    openItem(item);
  }

  function animateOpen(item) {
    const content = item.querySelector('[data-delivery-content]');

    if (!content) return;

    content.style.maxHeight = '0px';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        content.style.maxHeight = `${content.scrollHeight}px`;
      });
    });
  }

  function animateClose(item) {
    const content = item.querySelector('[data-delivery-content]');

    if (!content) return;

    content.style.maxHeight = `${content.scrollHeight}px`;
    void content.offsetHeight;
    content.style.maxHeight = '0px';
  }

  function openItem(item) {
    const trigger = item.querySelector('[data-delivery-trigger]');

    item.classList.add('is-open');
    trigger?.setAttribute('aria-expanded', 'true');
    animateOpen(item);
  }

  function closeItem(item) {
    const trigger = item.querySelector('[data-delivery-trigger]');

    animateClose(item);
    item.classList.remove('is-open');
    trigger?.setAttribute('aria-expanded', 'false');
  }
}

export const model = {};
